var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// field-configuration.ts
import { A } from "@adornis/base/env-info.js";
import { Entity } from "@adornis/baseql/decorators/entity.js";
import { Field } from "@adornis/baseql/decorators/field.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
var makeUniqueIDForFieldConf = ({ customID, fieldName }) => {
  return (customID ?? "-") + "#" + (fieldName ?? "-");
};
var FieldConfiguration = class extends AdornisEntity {
  static resolveID(entity) {
    return entity._id ??= A.getGloballyUniqueID();
  }
  constructor(doc) {
    if (!doc.customID && !doc.fieldName)
      throw new Error("has to have at least one of fieldName and customID");
    if (doc.customID && doc.fieldName) {
      throw new Error(
        `cant have customID and fieldName, choose one! customID=${doc.customID} fieldName=${doc.fieldName}`
      );
    }
    super(doc);
  }
};
FieldConfiguration._class = "FieldConfiguration";
__decorateClass([
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], FieldConfiguration.prototype, "_id", 2);
__decorateClass([
  Field((type) => String)
], FieldConfiguration.prototype, "fieldName", 2);
__decorateClass([
  Field((type) => String)
], FieldConfiguration.prototype, "customID", 2);
__decorateClass([
  Field((type) => String)
], FieldConfiguration.prototype, "columnWidth", 2);
__decorateClass([
  Field((type) => String)
], FieldConfiguration.prototype, "displayName", 2);
FieldConfiguration = __decorateClass([
  Entity()
], FieldConfiguration);
export {
  FieldConfiguration,
  makeUniqueIDForFieldConf
};
